import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import TagManager from 'react-gtm-module';
import { ToastContainer } from 'react-toastify';
import { pdfjs } from 'react-pdf';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import ErrorBoundary from './Components/Pages/error-boundary.js';
// eslint-disable-next-line import/no-unassigned-import
import './Services/i18n.js';
import App from './app.js';
import './template.styles.css';
import './index.css';

const prod = window.location.hostname === 'esign-proteantech.in';

if (prod) {
	const tagManagerArgs = {
		gtmId: 'GTM-NJFCT84G'
	};

	TagManager.initialize(tagManagerArgs);
}

i18next.init({
	interpolation: { escapeValue: false }
});

const root = ReactDOM.createRoot(window.document.querySelector('#root'));
// Set the workerSrc for pdfjs

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const renderApp = () => (
	<I18nextProvider i18n={i18next}>
		<ErrorBoundary>
			<ToastContainer />
			<App />
		</ErrorBoundary>
	</I18nextProvider>
);

root.render(renderApp());
